export default "__VITE_ASSET__BOWQERQV__$_?format=webp__"